import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { useAuth } from "contexts/auth-context";
const useStyles = makeStyles((theme) => ({
	layout: {
		boxSizing: "border-box",
		display: "flex",
		flex: "auto",
		flexDirection: "column",
		minHeight: 0,
		background: "#f0f2f5",
		"*": {
			boxSizing: "border-box",
		},
	},

	layoutSidebar: {
		height: `calc(100vh - 48px - 56px)`, //48px - 56px
		flexDirection: "row",
	},
	layoutSidebar2: {
		height: `calc(100vh - 69px - 55px)`, //48px - 56px
		flexDirection: "row",
	},
	sider: {
		position: "relative",
		// display: "none",
		[theme.breakpoints.up("md")]: {
			flex: `0 0 240px`,
			maxWidth: 240,
			minWidth: 240,
			width: 240,
		},
	},
	siderChildren: {
		height: "100%",
		marginTop: -0.1,
		paddingTop: 0.1,
	},
	hasSider: {
		overflowX: "hidden",
	},
	content: {
		flex: "auto",
		padding: theme.spacing(2),
		margin: 0,
		minHeight: 280,
		background: "#fffff",
		// display: "flex",
		// flexDirection: "column",
	},
}));
function Container({ children }) {
	const classes = useStyles();
	const { userHasScopeAccessPreview } = useAuth();
	return (
		<div
			className={clsx(classes.layout, userHasScopeAccessPreview() ? classes.layoutSidebar2 : classes.layoutSidebar, classes.hasSider)}
		>
			{children}
		</div>
	);
}
function SideBarContainer({ children }) {
	const classes = useStyles();
	return <aside className={classes.sider}>{children}</aside>;
}
function MainContent({ children }) {
	const classes = useStyles();
	return (
		<main className={clsx(classes.content, classes.hasSider)}>{children}</main>
	);
}
export { Container, SideBarContainer, MainContent };
